<template>
    <div>

    <section class="hero is-info is-bold">
      <div class="hero-body">
        <div class="container has-text-centered">
          <span>
            <font-awesome-icon icon="map-signs" size="2x" />
            <h1 class="title is-3">expedijob : offres d'emploi 100% télétravail</h1>
          </span>
        </div>
      </div>
    </section>

    <section>
    <div class="container">  
     <div class="box">
    <p>
     <br /> 
     Pour vous inscrire aux emails d'information expedijob, merci d'indiquer vos préférences et de sauvegarder, vous pouvez aussi vous désinscrire via cette page
     <br /> 
    </p>
    </div>
    </div>
    </section>

    <section class="section">
      <div class="container">  

          <div class="box">
          <!-- container with 1 left and 1 right side -->
            <nav class="level">
              <!-- Left side -->
              <div class="level-left">
                <div class="level-item">
                  <div class="tag is-light is-medium"> Recevoir des nouveaux jobs par email :</div>
                </div> 
              </div> 
              <!-- Right side -->
              <div class="level-right">   
                <div class="level-item">
                  <div class="field">
                    <b-switch v-model="isSwitchedCustom"
                      true-value="oui"
                      false-value="non">
                      {{ isSwitchedCustom }}
                    </b-switch>
                  </div>
                </div>
              </div>
            </nav>
          </div>

          <div class="box">
            <!-- container with 1 left and 1 right side -->
            <nav class="level">
              <!-- Left side -->
              <div class="level-left">
                <div class="level-item">
                  <div class="tag is-light is-medium"> Envoyer les jobs avec ce mot-clé :</div>  
                </div> 

                <div class="level-item">
                  <div class="field">
                    <input type="text" class="input" name="keyword" placeholder="Votre mot-clé" v-model="keyword">
                  </div> 
                </div> 
              </div> 

              <!-- Right side -->
              <div class="level-right">   
                <div class="level-item">
                  <font-awesome-icon icon="arrow-alt-circle-right" /> 
                  <div class="tag is-light is-medium"> il faut mettre un SEUL élément</div>                  
                </div>
              </div>
            </nav>
          </div> 

        <p>
          <i>Note : pour le mot-clé, vous pouvez utiliser un élément comme "graphiste" ou bien par exemple "ingénieur système"</i>
        </p>

        <br /> 
        <form id="signup-form" @submit.prevent="processForm">
          <div class="field has-text-right">
            <button type="submit" class="button is-primary">Confirmer vos paramètres</button>
          </div>
        </form>

      </div>
    </section>
    </div>
</template>

<script>
import axios from 'axios';
export default {
      data: function() {
        return {
         userId: this.$route.params.id,
         keyword: '',
         isSwitchedCustom: 'oui',
         apiUrl : '',
         retourmessage: ''
       };
      },
      methods: {
       sendMessage(payload) {
        var api_url = this.apiUrl+'/confirm_email/'+this.userId;
        axios.post(api_url, payload)
          .then(response => {
          this.retourmessage = response.data.messageretour;
          })
          .catch((error) => {
            console.log(error);
          });
        }, 
        processForm () {
          const payload = {
            keyword: this.keyword,
            switched: this.isSwitchedCustom
          };
          this.sendMessage(payload);
          alert("Vos paramètres sont sauvegardés");
        },
        getEmailData () {
          var api_url = this.apiUrl+'/emaildata/'+this.userId;
          axios.get(api_url)
          .then(response => {
            this.keyword = response.data.keyword;
            this.isSwitchedCustom = response.data.switch;
           })
          .catch(error => {
            console.log(error)
          })
        }
      }
      ,
      created () {
        this.getEmailData();
        this.apiUrl = process.env.API_URL;
      }
    };
</script>



// WEBPACK FOOTER //
// src/components/Souscription.vue